import axios from "axios";

export const axiosClient = axios.create({
    headers: {
        'Accept-Language': 'tr'
    }
});